/* eslint-disable @typescript-eslint/no-explicit-any */

import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/service/auth.service';
import { RoutingService } from 'src/app/service/routing.service';
import { ConfigService } from 'src/app/service/config.service';
import { BookmarkApiService } from 'src/app/shared/services/customer-api/bookmark-api.service';
import { MaintenanceApiService } from 'src/app/shared/services/customer-api/maintenance-api.service';
import { WhatsNewService } from 'src/app/shared/services/whats-new.service';
import { UserScopedStorageService } from 'src/app/shared/services/user-scoped-storage.service';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-cockpit',
  templateUrl: './cockpit.component.html',
  styleUrls: ['./cockpit.component.scss'],
})
export class CockpitComponent {
  params: any;
  impersonate: any;
  status: any;
  statusObject: any;

  constructor(
    private route: ActivatedRoute,
    public auth: AuthService,
    public routing: RoutingService,
    public config: ConfigService,
    private bookmarkApi: BookmarkApiService,
    private maintenanceApi: MaintenanceApiService,
    private whatsNew: WhatsNewService,
    private userStorage: UserScopedStorageService,
  ) {
    this.whatsNew.check();

    this.route.queryParams.subscribe((params) => {
      this.params = params;
    });

    this.impersonate = false;

    if (this.config.appConfig.setup.useStorage) {
      if (
        this.params.impersonate ||
        (localStorage.getItem('impersonate') !== undefined &&
          localStorage.getItem('impersonate') === this.auth.userdata?.email)
      ) {
        this.impersonate = true;
      }
    }

    this.maintenanceApi.getStatus().subscribe((result) => {
      this.statusObject = result;

      if (Object.prototype.hasOwnProperty.call(this.statusObject, 'message')) {
        this.status = true;
      } else {
        this.status = false;
      }
    });

    if (this.config.appConfig.setup.useStorage) {
      this.bookmarkApi.getStars().subscribe((result) => {
        this.userStorage.setItem('news_curation', result);
      });
    }
  }

  closeStatus() {
    this.status = false;
  }
}
